<template>
  <section>
    <overlay-alert
      :show-progress="showProgress"
      :process-alert="processAlert"
    />
    <div
      v-if="verificationFailed"
      class="fail-message-style mb-4"
    >
      <p class="fail-style">
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        {{ verificationFailedMessage }}
      </p>
    </div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p
          v-if="locationEnableCheck"
          class="process-header"
        >
          Location Verification
        </p>
        <p
          v-else
          class="process-header"
        >
          User Details
        </p>
      </v-card-title>
      <v-card-text>
        <p class="title-text-style">
          Name: <font class="value-text-style">
            {{ selectedOrganization.first_name }} {{ selectedOrganization.last_name }}
          </font>
        </p>
        <p class="title-text-style">
          Mobile: <font class="value-text-style">
            {{ selectedOrganization.phone_number }}
          </font>
        </p>
        <p class="title-text-style">
          Company: <font class="value-text-style">
            {{ selectedOrganization.company.name }}
          </font>
        </p>
        <p class="title-text-style">
          Category: <font
            v-if="selectedOrganization.worker_category !== null"
            class="value-text-style"
          >
            {{ selectedOrganization.worker_category.name }}
          </font>
          <font v-else>
            N/A
          </font>
        </p>
        <p class="title-text-style">
          Check-in Types:<font
            class="value-text-style"
          >
            {{ selectedOrganization.types | arrangePretty }}
          </font>
        </p>
      </v-card-text>
    </v-card>
    <v-btn
      :disabled="locationFetchFailed"
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="verifyLocation()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import OverlayAlert from 'src/views/components/OverlayAlert';

  export default {
    name: 'ContractorLocVerification',
    components: {
      'centre-spinner': spinner,
      'overlay-alert': OverlayAlert,
    },
    filters: {
      arrangePretty (val) {
  if (Array.isArray(val)) {
    return val.map(type => type === 'staff' ? 'Site Manager' : type).join(', ');
  }
  return val;
},
    },
    props: {
      orgSettings: {
        type: Object,
        default: null,
      },
    },
    data: () => ({
      loading: false,
      verificationFailed: false,
      verificationFailedMessage: '',
      showProgress: false,
      processAlert: '',
      latitudeValue: null,
      longitudeValue: null,
      locationFetchFailed: false,
    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      locationEnableCheck () {
        return this.orgSettings.location_verification;
      },
    },
    mounted () {
      this.fetchLocationDetails();
    },
    methods: {
      fetchLocationDetails () {
        if (navigator.geolocation) {
          this.showProgress = true;
          this.processAlert = 'Checking In...';
          navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
        } else {
          this.showProgress = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'Geolocation is not supported by this browser.';
        }
      },
      showPosition (position) {
        this.latitudeValue = position.coords.latitude;
        this.longitudeValue = position.coords.longitude;
        this.showProgress = false;
      },
      showError (error) {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'User denied the request for location access. Please close the tab and relaunch our app once access is enabled.';
          break;
          case error.POSITION_UNAVAILABLE:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'Location information is unavailable.';
          break;
          case error.TIMEOUT:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'The request to get user location timed out.';
          break;
          case error.UNKNOWN_ERROR:
            this.showProgress = false;
            this.locationFetchFailed = true;
            this.verificationFailed = true;
            this.verificationFailedMessage = 'An unknown error occurred.';
          break;
        }
      },
      verifyLocation () {
        this.loading = true;
        this.$store.dispatch('swiftuser/clearScannedLocationName');
        const siteId = this.$route.params.siteId;
        this.$store.dispatch('swiftuser/verifyLocation', {
          orgExtId: this.selectedOrganization.organization.external_id,
          details: {
          project_gate_id: siteId,
          checkin_latitude: this.latitudeValue.toString(),
          checkin_longitude: this.longitudeValue.toString(),
          checkin_type: 'check-in',
          },
        }).then(response => {
          this.loading = false;
          this.$emit('verification-completed');
        }).catch(error => {
          this.loading = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
    },
  };
  </script>

<style scoped>
.v-btn.theme--dark.v-btn--disabled.v-btn--has-bg {
  background: rgb(202, 202, 202) !important;
}
</style>
